module.exports = __webpack_public_path__ + "img/bio-pic-1-128-184.f809a720.jpg";